import {
  Box,
  Button,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useApiClient } from "../../context/ApiClientContext";
import toast from "react-hot-toast";
import ComponentBackdrop from "../../components/backdrop";
import api from "../../helper/baseApi";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../../helper/successAlert";
import ErrorAlert from "../../helper/errorAlert";

const Form = ({ mode, jobData, jobId, onModeChange, onSuccess }) => {
  const { id } = useParams();
  const labelWidth = 150;
  const [errors, setErrors] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const navigate = useNavigate();

  const [inputForm, setInputForm] = useState({
    name: "",
    description: "",
  });


  useEffect(() => {
    if (mode === "edit" || mode === "view") {
      const jobGrade = jobData || {};

      setInputForm({
        ...jobGrade,
      });
    } else {
      setInputForm({
        name: "",
        description: "",
      });
    }
  }, [mode, jobData]);

  const handleInputChange = (property, event) => {
    var value = event.target.value;
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const changeEdit = () => {
    onModeChange("edit");
  };


  const submitForm = async () => {
    let newErrors = {};

    if (!inputForm.name || inputForm.name.trim() === "") {
      newErrors.name = "Job Grade is required";
    }

    // if any errors, stop submit
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setOpenBackdrop(true);

      let response = '';
      let apiUrl = '';

      if (mode === 'edit') {
        apiUrl = `${mobileApiUrl}jobGrade/update-details`;
        response = await api.put(apiUrl, {
          jobGradeId: jobId,
          name: `${inputForm.name}`,
          description: `${inputForm.description}`,
        });
      } else {
        apiUrl = `${mobileApiUrl}jobGrade/create-details`;

        response = await api.post(apiUrl, {
          name: `${inputForm.name}`,
          description: `${inputForm.description}`,
        });
      }

      if (response.status == 200) {
        setTimeout(() => {
          if (mode === "create" || mode === "edit") {
            onModeChange(false);
            onSuccess();
          }
          setOpenBackdrop(false);
          SuccessAlert(response.data.message);
        }, 2000);
      }
    } catch (error) {
      ErrorAlert(error, navigate);
      setOpenBackdrop(false);
    }
  };

  const SubmitButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={() => submitForm("Successfully created.")}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
          //   mb: 3,
        }}
      >
        Save
      </Button>
    </Box>
  );
  const EditButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={mode === "edit" ? submitForm : changeEdit}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
        }}
      >
        {mode === "edit" ? "Save" : "Edit"}
      </Button>
    </Box>
  );

  const renderField = (
    label,
    id,
    type = "text",
    select = false,
    options = [],
    disabled = false
  ) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        // mb: 2,
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
          minHeight: 50
        }}
      >
        {label}
      </Typography>
      <TextField
        id={id}
        type={type}
        select={select}
        slotProps={{
          input: { readOnly: disabled }
        }}
        error={!!errors[id]}
        helperText={errors[id] || " "}  // <-- space keeps height consistent
        // FormHelperTextProps={{ style: { minHeight: "20px" } }}
        onChange={(e) => handleInputChange(id, e)}
        value={inputForm[id]}
        required
        fullWidth
        size="small"
        variant="outlined"
      >
        {select &&
          options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );
  return (
    <Box sx={{ width: "100%" }}>
      <Box width="100%" display="flex" justifyContent="flex-end" mb={2}>
        {mode === "create" ? (
          <SubmitButton />
        ) : (
          <EditButton changeEdit={changeEdit} />
        )}{" "}
      </Box>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid size={{ xs: 12 }}>
          {renderField(
            "Job Grade",
            "name",
            "text",
            false,
            [],
            mode === "view"
          )}
          {renderField(
            "Job Description",
            "description",
            "text",
            false,
            [],
            mode === "view"
          )}
        </Grid>
      </Grid>
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </Box>
  );
};

export default Form;
